import { render, staticRenderFns } from "./RecordingDetailsTabRecording.vue?vue&type=template&id=1fbcfb84"
import script from "./RecordingDetailsTabRecording.vue?vue&type=script&lang=js"
export * from "./RecordingDetailsTabRecording.vue?vue&type=script&lang=js"
import style0 from "./RecordingDetailsTabRecording.vue?vue&type=style&index=0&id=1fbcfb84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports